module.exports = __webpack_public_path__ + "img/knsu_gallery13.f8c175f0.jpg";